export const baseMultipliers = {
  shielder: 1.0,
  saber: 1.0,
  archer: 0.95,
  lancer: 1.05,
  rider: 1.0,
  caster: 0.9,
  assassin: 0.9,
  berserker: 1.1,
  ruler: 1.1,
  avenger: 1.1,
  moonCancer: 1.0,
  alterEgo: 1.0,
  foreigner: 1.0,
  pretender: 1.0,
};

export const classIndices = {
  shielder: 0,
  saber: 1,
  archer: 2,
  lancer: 3,
  rider: 4,
  caster: 5,
  assassin: 6,
  berserker: 7,
  ruler: 8,
  avenger: 9,
  moonCancer: 10,
  alterEgo: 11,
  foreigner: 12,
  pretender: 13,
  beast: 14,
};

// rows = attacker class index, cols = defender class index
export const classAdvantageMatrix = [
  [1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0],
  [1.0, 1.0, 0.5, 2.0, 1.0, 1.0, 1.0, 2.0, 0.5, 1.0, 1.0, 1.0, 1.0, 1.0, 0.5],
  [1.0, 2.0, 1.0, 0.5, 1.0, 1.0, 1.0, 2.0, 0.5, 1.0, 1.0, 1.0, 1.0, 1.0, 0.5],
  [1.0, 0.5, 2.0, 1.0, 1.0, 1.0, 1.0, 2.0, 0.5, 1.0, 1.0, 1.0, 1.0, 1.0, 0.5],
  [1.0, 1.0, 1.0, 1.0, 1.0, 2.0, 0.5, 2.0, 0.5, 1.0, 1.0, 1.0, 1.0, 1.0, 0.5],
  [1.0, 1.0, 1.0, 1.0, 0.5, 1.0, 2.0, 2.0, 0.5, 1.0, 1.0, 1.0, 1.0, 1.0, 0.5],
  [1.0, 1.0, 1.0, 1.0, 2.0, 0.5, 1.0, 2.0, 0.5, 1.0, 1.0, 1.0, 1.0, 1.0, 0.5],
  [1.0, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 0.5, 1.5, 0.5],
  [1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 2.0, 1.0, 0.5, 2.0, 1.0, 1.0, 1.0, 2.0],
  [1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 2.0, 2.0, 1.0, 0.5, 1.0, 1.0, 1.0, 2.0],
  [1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 2.0, 0.5, 2.0, 1.0, 1.0, 1.0, 1.0, 2.0],
  [1.0, 0.5, 0.5, 0.5, 1.5, 1.5, 1.5, 2.0, 1.0, 1.0, 1.0, 1.0, 2.0, 0.5, 2.0],
  [1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 2.0, 1.0, 1.0, 1.0, 0.5, 2.0, 2.0, 2.0],
  [1.0, 1.5, 1.5, 1.5, 0.5, 0.5, 0.5, 2.0, 1.0, 1.0, 1.0, 2.0, 0.5, 1.0, 2.0],
  [1.0, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 2.0, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 1.0],
];

export const attributeDict = {
  human: { human: 1.0, earth: 0.9,  sky: 1.1,  star: 1.0, beast: 1.0 },
  earth: { human: 1.1, earth: 1.0,  sky: 0.9,  star: 1.0, beast: 1.0 },
  sky:   { human: 0.9, earth: 1.1,  sky: 1.0,  star: 1.0, beast: 1.0 },
  star:  { human: 1.0, earth: 1.0,  sky: 1.0,  star: 1.0, beast: 1.1 },
  beast: { human: 1.0, earth: 1.0,  sky: 1.0,  star: 1.1, beast: 1.0 },
};

// Atlas trait individuality ids per class (used for class-conditional passives
// like Kazuradrop 同属嫌悪, and the overwriteBattleclass class-swap path).
// Beast is intentionally absent — no servant class-changes into Beast.
export const classTraitByName = {
  saber:      100,
  archer:     102,
  lancer:     101,
  rider:      103,
  caster:     104,
  assassin:   105,
  berserker:  106,
  shielder:   107,
  ruler:      108,
  alterEgo:   109,
  avenger:    110,
  moonCancer: 115,
  foreigner:  117,
  pretender:  120,
};

export const classNameByTrait = Object.fromEntries(
  Object.entries(classTraitByName).map(([name, id]) => [id, name])
);
